<template>
  <div>
    <el-upload
      v-loading="loading"
      :limit="1"
      :http-request="loadFile"
      :before-remove="beforeRemove"
      :on-exceed="handleExceed"
      :file-list="fileList"
      :accept="acceptedFile"
      action=""
    >
      <el-button class="upload-button">
        {{ $t('admin.uploadFileButton') }}
      </el-button>
      <div class="el-upload__tip">
        {{ $t('uploadMenu.uploadHint') }}
      </div>
    </el-upload>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import weeklyMenuParser from '@/utils/weeklyMenuParser';
import moment from 'moment';

export default {
  name: 'FileUploader',
  props: {
    acceptedFile: {
      type: String,
      required: true,
    },
    officeId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      fileList: [],
      dataFromFile: {},
      loading: false,
    };
  },
  computed: {
    ...mapState('offices', { offices: (state) => state.offices }),
    ...mapState('diets', { diets: (state) => state.diets }),
    ...mapState('events', { mealEvents: (state) => state.mealEvents }),
    ...mapState('weeklyMenu', {
      newMenuUploadedCorrectly: (state) => state.newMenu.uploadedCorrectly,
      newMenuIsValid: (state) => state.newMenu.isValid,
    }),
  },
  watch: {
    newMenuUploadedCorrectly: 'handleUploadedCorrectlyChange',
    newMenuIsValid: 'handleIsValidChange',
  },
  methods: {
    handleExceed() {
      this.$message.warning(this.$t('admin.exceededFileLimitMessage'));
    },
    beforeRemove() {
      return this.$confirm(this.$t('admin.beforeRemoveFileMessage'));
    },
    async loadFile(fileData) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        try {
          const fileContent = fileReader.result;
          this.dataFromFile = weeklyMenuParser(
            fileContent,
            this.officeId,
            this.diets,
            this.mealEvents
          );
          this.validateMenu({
            startDate: this.dataFromFile.startDate,
            endDate: this.dataFromFile.endDate,
            office: this.officeId,
          });
        } catch (errorFromMenuParser) {
          this.$message.error(this.$t(errorFromMenuParser.message));
          this.fileList = [];
          this.setNewMenuDefaultValues();
        }
      };
      fileReader.readAsText(fileData.file);
    },
    async showConfirmDialog() {
      try {
        const startDate = moment(this.dataFromFile.startDate);
        const endDate = moment(this.dataFromFile.endDate);
        const rangeDates = `(${startDate.format('MMMM DD')} - ${endDate.format('MMMM DD')})`;
        const message = this.$t('admin.repeatedMenuMessageBoxText').replace('()', rangeDates);
        const confirmResponse = await this.$confirm(message, '', {
          confirmButtonText: this.$t('admin.repeatedMenuMessageBoxConfirmButton'),
          type: 'warning',
        });
        if (confirmResponse === 'confirm') {
          this.loading = true;
          this.saveMenu(this.dataFromFile.menuEvents);
        }
      } catch (cancelResponse) {
        this.fileList = [];
        this.setNewMenuDefaultValues();
      }
    },
    async handleIsValidChange() {
      if (this.newMenuIsValid === undefined) {
        // eslint-disable-next-line no-useless-return
        return;
      }
      if (this.newMenuIsValid) {
        this.loading = true;
        this.saveMenu(this.dataFromFile.menuEvents);
      } else {
        this.showConfirmDialog();
      }
    },
    handleUploadedCorrectlyChange() {
      if (this.newMenuUploadedCorrectly === undefined) {
        // eslint-disable-next-line no-useless-return
        return;
      }
      if (this.newMenuUploadedCorrectly) {
        this.loading = false;
        this.$message.success(this.$t('admin.menuParserMessages.successUpload'));
        this.setNewMenuDefaultValues();
      } else {
        this.loading = false;
        this.$message.error(this.$t('admin.menuParserMessages.errorUpload'));
        this.fileList = [];
        this.setNewMenuDefaultValues();
      }
    },
    ...mapActions('weeklyMenu', {
      validateMenu: 'validateMenu',
      setNewMenuDefaultValues: 'setNewMenuDefaultValues',
      saveMenu: 'saveMenu',
    }),
  },
};
</script>
<style scoped lang="scss">
@import '../scss/variables';
.el-message-box {
  height: 180px;
  &__message p {
    font-family: 'Avenir';
  }
}
.upload-button {
  width: 105px;
}
/deep/ .el-upload {
  &__tip {
    text-align: center;
    font-size: $label-description-text-size;
  }
}
/deep/ .el-upload-list {
  &--text {
    text-align: left;
  }
  /deep/ .el-icon-close-tip {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FileUploader.vue